import useNotificationHandler from "hooks/useNotificationHandler";
import { QUERY_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { UseQueryResult, useQuery, useQueryClient } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number | string | null;
  clientInternalNumberGOS: number | string;
  hbhObjectType?: number;
  attachmentObjectTag?: string;
  attachmentType?: number;
  enabled?: boolean;
};

const getAttachments = async ({
  countryCode,
  clientInternalNumberGOS,
  hbhObjectType = 0,
  attachmentObjectTag = ` `,
  attachmentType = 0,
}: Params) => {
  if (countryCode === null || clientInternalNumberGOS === null) return;

  const response = await api.get(
    `/attachments/${countryCode}/${clientInternalNumberGOS}/${hbhObjectType}/${attachmentObjectTag}/${attachmentType}`
  );
  return response.data;
};

export function useGetAttachments({
  countryCode,
  clientInternalNumberGOS,
  hbhObjectType,
  attachmentObjectTag,
  attachmentType,
  enabled = true,
}: Params): UseQueryResult<Attachment[]> {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useQuery<Attachment[], Error>(
    [
      QUERY_KEYS.attachments,
      countryCode,
      clientInternalNumberGOS,
      hbhObjectType,
      attachmentObjectTag,
      attachmentType,
    ],
    () =>
      getAttachments({
        countryCode,
        clientInternalNumberGOS,
        hbhObjectType,
        attachmentObjectTag,
        attachmentType,
      }),
    {
      refetchOnMount: true,

      // cacheTime: 0,
      enabled: enabled,
      onError: (error: any) => {
        handleAddAxiosErrorNotification(error);
      },
    }
  );
}

export const useInvalidateAttachments = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.attachments });
};
